<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © MifMaroc.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Powered by <a href="" class="text-info">genymob</a>
                </div>
            </div>
        </div>
    </div>
</footer>